package io.horion.auth.utils

import kotlinx.browser.window

object UserEnvironmentHelper {
    fun getLocalTimezone(): String {
        return try {
            js("Intl.DateTimeFormat().resolvedOptions().timeZone") as? String ?: "Africa/Douala"
        } catch (e: Exception) {
            "Africa/Douala"
        }
    }

    fun getCountryCodeFromBrowser(): String {
        return try {
            val language = window.navigator.language // Ex: "fr-CM", "en-US"
            if (language.contains("-")) {
                language.substringAfter("-").lowercase()
            } else {
                "cm"
            }
        } catch (e: Exception) {
            "cm"
        }
    }

    fun getCountryNameFromCode(code: String): String {
        if (code.isBlank()) return "Cameroun"
        return try {
            val userLang = window.navigator.language.substringBefore("-") // ex: "fr"
            val displayNames = js("new Intl.DisplayNames([userLang], { type: 'region' })")
            val countryName = displayNames.of(code.uppercase()) as? String

            if (!countryName.isNullOrBlank()) countryName else "Cameroun"
        } catch (e: Exception) {
            "Cameroun"
        }
    }

    fun inferCityFromTimezone(timezone: String): String {
        if (timezone.isBlank()) return "Douala"
        return try {
            val rawCity = timezone.substringAfterLast("/")
            val cleanCity = rawCity.replace("_", " ").trim()
            if (cleanCity.isNotBlank()) cleanCity else "Douala"
        } catch (e: Exception) {
            "Douala"
        }
    }
}